export default __webpack_public_path__ + "static/media/image20tum.cc5c0008.jpg";